import clsx from "clsx";
import st from "@/styles/VerifyAccount.module.scss";
import FaceLivenessCheck from "@/components/FaceLivenessCheck.tsx";
import {useEffect, useRef} from "react";
import useNotifications from "@/hooks/notifications.ts";


const KYCStepTwo = () => {
    const notif = useNotifications()
    const effect_ran = useRef<boolean>(false)
    
    useEffect(() => {
        
        if(!effect_ran.current){
            localStorage.removeItem("AmplifyLivenessCameraId")
            notif.upd_technical()
        }
        
        return () => {
            effect_ran.current = true
        }
    }, []);

    
    return (
        <div className={clsx(st.column_center, st.third_step)}>
            <FaceLivenessCheck />
        </div>
    )
}

export default KYCStepTwo